const isPlanHeaderLine = (line: string): boolean => {
  const t = (line || '').trim()
  if (!t) return false
  return /^\s*(?:[-*+]\s*\[[ xX]\]\s*)?(?:\*{0,2}\s*)?(?:📋|🎯|📊|⭐|🔖)?\s*(?:\*{0,2}\s*)?(?:analysis\s+)?plan\b\s*:?\s*\*{0,2}\s*$/iu.test(t)
}

const isPlanBodyLine = (line: string): boolean => {
  const t = (line || '').trim()
  if (!t) return true
  if (/^(?:\*{0,2}\d+[.)]\*{0,2}\s+).+/.test(t)) return true
  if (/^(?:[-*+]\s+(?:\[[ xX]\]\s*)?).+/.test(t)) return true
  if (/^step\s+\d+\s*:\s+.+/i.test(t)) return true
  if (/^\s{2,}\S+/.test(line)) return true
  return false
}

const stripOneLeadingPlanBlock = (content: string): string => {
  if (!content) return content
  const lines = content.replace(/^\uFEFF/, '').split('\n')
  let i = 0
  while (i < lines.length && lines[i].trim() === '') i++
  if (i >= lines.length) return content
  if (!isPlanHeaderLine(lines[i])) return content

  i++
  while (i < lines.length && lines[i].trim() === '') i++

  let consumed = 0
  while (i < lines.length) {
    if (!isPlanBodyLine(lines[i])) break
    consumed++
    i++
  }
  if (consumed === 0) return content

  while (i < lines.length && lines[i].trim() === '') i++

  // Also trim the short bridge prose that often trails the plan block.
  const interimStart = i
  let interimChars = 0
  let interimLines = 0
  while (i < lines.length && interimLines < 5 && interimChars < 420) {
    const t = lines[i].trim()
    if (!t) {
      i++
      break
    }
    if (/^#{1,6}\s/.test(t) || /^---+\s*$/.test(t)) break
    if (/^\s*\|/.test(lines[i]) && t.includes('|')) break
    interimChars += lines[i].length + 1
    interimLines++
    i++
  }
  if (interimChars >= 420 || interimLines >= 5) i = interimStart

  while (i < lines.length && lines[i].trim() === '') i++
  return lines.slice(i).join('\n').trimStart()
}

export const stripLeadingPlanBlock = (content: string): string => {
  let next = content || ''
  // Repeatedly strip leading plan blocks in case the model duplicated them.
  for (let pass = 0; pass < 3; pass++) {
    const stripped = stripOneLeadingPlanBlock(next)
    if (stripped === next) break
    next = stripped
  }
  return next
}

